import React, { Component } from 'react';
import _ from 'lodash';
import firebase from '../helper/firebase';
import { Avatar, CardHeader, CardContent, Chip } from 'material-ui';
import Fade from 'material-ui/transitions/Fade';
import CheckIcon from 'material-ui-icons/Check';
import EmailIcon from 'material-ui-icons/Email';

import '../styles/OfferSharedRecipientsCard.css';

export default class OfferSharedRecipientsCard extends Component {
	reinvitation = key => {
		console.log(`${key} clicked`);
		const invitation = this.props.recipients[key];
		var reinvitation = firebase.functions().httpsCallable('reinvitation');
		let reinvitationObject = {
			recipientEmail: invitation.recipientEmail,
			oid: invitation.oid,
			invitationKey: key,
			recipientAbout: invitation.recipientAbout,
			rating: invitation.rating
		};
		reinvitation(reinvitationObject);
	};
	render() {
		const { recipients } = this.props;
		return (
			<React.Fragment>
				<CardHeader
					subheader={
						_.isEmpty(recipients) &&
						'Candidates that you invite will appear below.'
					}
				/>
				<CardContent className="recipients">
					{Object.keys(recipients).map(rec => {
						let recipient = recipients[rec];
						return (
							<Fade key={recipient.recipientEmail} in={true}>
								<Chip
									onClick={
										!recipient.emailSent
											? recipient => this.reinvitation(rec)
											: null
									}
									className="chip"
									avatar={
										recipient.emailSent ? (
											<Avatar className="avatarCheckIcon">
												<CheckIcon />
											</Avatar>
										) : (
											<Avatar className="emailIcon">
												<EmailIcon />
											</Avatar>
										)
									}
									label={recipient.recipientEmail}
								/>
							</Fade>
						);
					})}
				</CardContent>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/OfferSharedRecipientsCard.js